import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useConsent } from "../context/ConsentContext";

const Footer = () => {
  const { t } = useTranslation();
  const { openSettings } = useConsent();

  return (
    <footer className="bg-background-light dark:bg-background-dark text-center text-sm text-gray-500 dark:text-gray-400 py-2 border-t border-gray-200 dark:border-neutral-700 space-y-1">
      <div>
        {t("footer.company_name")} · {t("footer.ein")} · {t("footer.address")}
      </div>

      <div>
        <Link to="/cookies-policy" className="underline hover:text-gray-700 dark:hover:text-gray-200">
          {t("cookie.learn_more")}
        </Link>

        <span className="mx-2">|</span>

        <button
          type="button"
          onClick={openSettings}
          className="underline text-primary-light dark:text-primary-dark hover:opacity-70 transition"
        >
          {t("cookie.settings", "Cookie settings")}
        </button>
      </div>

      <div>
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </div>
    </footer>
  );
};

export default Footer;